import { create } from "zustand";

interface HookProps {
  open: boolean;
  loanId: string;
  setLoanId: (id: string) => void;
  onOpenChange: (open: boolean) => void;
}

export const useDeleteLoanModal = create<HookProps>()((set) => ({
  open: false,
  loanId: "",
  setLoanId: (id) =>
    set(() => ({
      loanId: id,
    })),
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
}));
